export default __webpack_public_path__ + "static/media/paystub-example-Cast&Crew.5987288c.jpg";